import React, { Fragment, useEffect, useState, useRef } from 'react';
import { DataGridPro, GridRowEditStopReasons, GridRowModes, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import '../modals.css';

const DisplayMessageRecips = ( { close, aid, uid, mid, contacts, loans, comms, messages } ) => {
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ msgSubject, setMsgSubject ] = useState( '' );
    const [ loading, setLoading ] = useState( true );
    const [ rows, setRows ] = useState( [] );

    let cols = [
        { 
            field: 'name', 
            headerName: 'Contact', 
            width: 200, 
            renderCell: ( params ) => <Link to={`/contact/${params.row.cid}`}>{params.value}</Link>, 
        },
        { 
            field: 'open', 
            headerName: 'Opened', 
            flex: 1
        },
        { 
            field: 'click', 
            headerName: 'Click', 
            flex: 1
        },
        { 
            field: 'bounce', 
            headerName: 'Bounce', 
            flex: 1
        },
        { 
            field: 'unsubscribe', 
            headerName: 'Unsubscribe', 
            flex: 1
        },
        { 
            field: 'spam', 
            headerName: 'Spam', 
            flex: 1
        },
        { 
            field: 'firstOpen', 
            headerName: 'First Opened', 
            width: 225,
            type: 'date',
            valueFormatter: ( params ) => {
                if ( !params.value ) {
                    return '';
                }
                return new Date( params.value ).toLocaleString();
            }
        },
        { 
            field: 'latestOpen', 
            headerName: 'Last Opened', 
            width: 225,
            type: 'date',
            valueFormatter: ( params ) => {
                if ( !params.value ) {
                    return '';
                }
                return new Date( params.value ).toLocaleString();
            }
        }

    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    // const toolbar = () => {
    //     return(
    //         <GridToolbarContainer>
    //             <Container fluid className='p-0'>
    //                 <Row className='p-0 align-items-center'>
    //                     <Col>
    //                         <Row className='text-start align-items-center'>
    //                             <Col xs='auto' className='pe-0'>
    //                                 <GridFooter className='tf-fake-footer' />
    //                             </Col>
    //                             <Col>
    //                                 { 
    //                                     selectedRows.length > 0 &&
    //                                     <Row style={ { borderLeft: '1px solid #CCC' } }>
    //                                         <Col xs='auto' className='pe-2'>Take Action...</Col>
    //                                         <Col xs='auto' className='ps-0'>
    //                                             {/* <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
    //                                                 <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
    //                                                 {
    //                                                     hasTxting ? (
    //                                                         <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
    //                                                     ) : (
    //                                                         null
    //                                                     )
    //                                                 }
    //                                                 <Dropdown.Divider />
    //                                                 <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item>
    //                                                 {
    //                                                     hasPhoneBurner ? (
    //                                                         <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
    //                                                     ) : (
    //                                                         null
    //                                                     )
    //                                                 }
    //                                             </DropdownButton> */}
    //                                         </Col>
    //                                     </Row>
    //                                 }
    //                             </Col>
    //                         </Row>
    //                     </Col>
    //                     <Col xs='auto' className='text-right'>
    //                         <GridToolbarQuickFilter />
    //                     </Col>
    //                     {
    //                         ( canExport ) ? (
    //                             <Col xs='auto' className='pe-3 text-right'>
    //                                 <GridToolbarExport />
    //                             </Col>
    //                         ) : (
    //                             null
    //                         )
    //                     }
    //                 </Row>
    //             </Container>
    //         </GridToolbarContainer>
    //     )
    // }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        height: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        if ( mid && messages ) {
            const m = messages[mid];
            if ( m ) {
                setMsgSubject( m.subject );
            }
        }
    }, [ mid, messages ] );

    useEffect( () => {
        console.log( 'incoming mid: ', mid );
        const list = [];

        Object.keys( comms ).forEach( co => {
            const comm = comms[co];
            if ( comm.msgId !== mid || !comm.assoc?.length ) {
                return;
            }
            const cid = comm.assoc[0].cid;
            const c = contacts[cid];
            
            if ( c ) {
                list.push( {
                    ...comm,
                    ...c,
                } );
            }
        } );

        console.log( 'setting rows: ', list );
        setRows( list );
        setLoading( false );
    }, [ mid, contacts, comms, loans ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Recipients of {msgSubject}</Col>
                </Row>
                <Row className='pt-3 pb-2'>
                    <Col style={ { height: '85vh' } }>
                        <DataGridPro
                            apiRef={gridRef}
                            loading={ loading }
                            rows={rows}
                            columns={cols}
                            density='compact'
                            checkboxSelection
                            disableSelectionOnClick
                            // slots={ { toolbar: toolbar } }
                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                            getRowId={ ( row ) => row.cid }
                        />
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    comms: state.comms.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    messages: state.messages.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( DisplayMessageRecips );